import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const DisputeCard = ({ dispute, statusConfig, onClick }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-error';
      case 'medium':
        return 'text-warning';
      case 'low':
        return 'text-success';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div
      onClick={onClick}
      className="bg-card rounded-lg border border-border p-6 hover:shadow-elevation-2 transition-smooth cursor-pointer"
    >
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        {/* Left Section */}
        <div className="flex items-start space-x-4 flex-1">
          {/* Trailer Image */}
          <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
            <Image
              src={dispute?.trailerImage}
              alt={dispute?.trailerImageAlt}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Details */}
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="flex-1">
                <h3 className="font-heading text-lg font-semibold text-foreground mb-1">
                  {dispute?.title}
                </h3>
                <p className="font-caption text-sm text-muted-foreground">
                  Case #{dispute?.caseNumber}
                </p>
              </div>
              <div className={`flex items-center space-x-1 px-3 py-1 rounded-full ${statusConfig?.color}`}>
                <Icon name={statusConfig?.icon} size={14} strokeWidth={2} />
                <span className="font-caption text-xs font-semibold">{statusConfig?.label}</span>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-4 text-sm">
              <div className="flex items-center space-x-2">
                <Icon name="Package" size={16} className="text-muted-foreground" strokeWidth={2} />
                <span className="font-body text-muted-foreground">{dispute?.trailerName}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="User" size={16} className="text-muted-foreground" strokeWidth={2} />
                <span className="font-body text-muted-foreground">
                  vs. {dispute?.opposingParty} ({dispute?.opposingPartyRole})
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="DollarSign" size={16} className="text-muted-foreground" strokeWidth={2} />
                <span className="font-body font-semibold text-foreground">${dispute?.amount}</span>
              </div>
            </div>

            <div className="flex items-center space-x-4 mt-3">
              <div className="flex items-center space-x-1">
                <Icon name="Calendar" size={14} className="text-muted-foreground" strokeWidth={2} />
                <span className="font-caption text-xs text-muted-foreground">
                  Filed: {dispute?.createdDate}
                </span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Clock" size={14} className="text-muted-foreground" strokeWidth={2} />
                <span className="font-caption text-xs text-muted-foreground">
                  Updated: {dispute?.lastUpdate}
                </span>
              </div>
              <div className={`flex items-center space-x-1 ${getPriorityColor(dispute?.priority)}`}>
                <Icon name="Flag" size={14} strokeWidth={2} />
                <span className="font-caption text-xs font-semibold">
                  {dispute?.priority?.charAt(0)?.toUpperCase() + dispute?.priority?.slice(1)} Priority
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section - Actions */}
        <div className="flex lg:flex-col gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Eye"
            onClick={(e) => {
              e?.stopPropagation();
              onClick();
            }}
            className="flex-1 lg:flex-none"
          >
            View Details
          </Button>
          {dispute?.status === 'awaiting_response' && (
            <Button
              variant="default"
              size="sm"
              iconName="MessageSquare"
              onClick={(e) => {
                e?.stopPropagation();
                onClick();
              }}
              className="flex-1 lg:flex-none"
            >
              Respond
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DisputeCard;